import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lc_top-icon-3",
  "use": "lc_top-icon-3-usage",
  "viewBox": "0 0 1 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1 22\" class=\"design-iconfont\" id=\"lc_top-icon-3\">\r\n  <path d=\"M0 0H1V22H0z\" fill=\"#EFEFEF\" fill-rule=\"evenodd\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol